export interface DisclaimersType {
    name: string;
    disclaimers: Array<DisclaimerType>;
}

export interface DisclaimerType {
    theme: string;
    title: string;
    description: string;
    dontShowAgain: string;
}

export const Disclaimers = [
    {
        name: 'market-data',
        disclaimers: [
            {
                theme: 'carnegie',
                title: 'Notifikation om marknadsdata',
                description:
                    'Innehaven är värderade enligt senaste kända kurs för respektive innehav och kan i vissa fall vara indikativ. Anskaffningsvärdena i ovanstående sammanställning av innehav bygger på för oss tillgängliga och i vissa fall ej verifierade värden. Carnegie kan således inte garantera uppgifternas riktighet. Vänligen kontrollera att angivna anskaffningsvärden överensstämmer med Era noteringar. Det är anskaffningsvärdet som ligger till grund för beräkningen av realiserat samt orealiserat resultat. Ingen hänsyn tas till skattemässiga regler och rapportverktyget är ej avsett som underlag för bokföring och deklaration.',
                dontShowAgain: 'Visa inte igen'
            }
        ]
    }
];
